package org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.components.dialogs

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.backgroundDialog
import org.hs_soft.runmynesto.domain.config.generalDialogSetting
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomTextArea
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.components.dialog.component.DialogTitle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun ClosingDailyReportDialog(
    modifier: Modifier = Modifier,
    submitClosingDailyReport: (String) -> Unit,
    onCloseClick: () -> Unit,
    loading: Boolean,
)
{
    val report= remember { mutableStateOf("") }

    Box(
        modifier = Modifier
            .backgroundDialog()
            .onClick {
                onCloseClick()
            }
    ){
        Column(
            modifier = modifier
                .align(Alignment.Center)
                .margin(top = Dimen.normalPadding)
                .width(Dimen.closingDailyReportDialogWidth)
                .height(Dimen.daysFilterDialogHeight)
                .generalDialogSetting()
                .zIndex(Constants.ZIndex.mediumZIndex)
                .border(
                    width= Dimen.smallThickness,
                    style = LineStyle.Solid,
                    color = Theme.ActionDisabledBackground.rgb
                ) ,
            horizontalAlignment = Alignment.CenterHorizontally

        ) {
            DialogTitle(
                title = Strings.current().disableCompletion,
                showSeparator = false,
                leftRightPadding = Dimen.largePadding,
                showCloseIcon = true
            ) {
                onCloseClick()
            }


            Column(
                modifier=Modifier
                    .fillMaxWidth()
                    .weight(1f)
                    .padding(Dimen.largePadding)
            )
            {
                CustomTextArea(
                    fillMaxHeight = true,
                    fillMaxWidth = true,
                    value = report.value,
                    label = Strings.current().reason,
                    maxHeight =(2*Dimen.normalTextAreaHeight.value.toInt()).px,
                    height = Dimen.normalTextAreaHeight,
                    onFocusOut = {}
                ) {
                    report.value = it
                }

                Spacer()

                CustomButton(
                    modifier = Modifier
                        .fillMaxWidth(),
                    loading = loading,
                    isClickable = report.value.isNotEmpty(),
                    title = Strings.current().apply,
                    buttonType = ButtonTypes.CONTAINED,
                    onButtonClick = {
                        submitClosingDailyReport(report.value)
                    },
                )
            }


        }
    }






}